export { Identification as default } from './Identification';
